if (!customElements.get('contact-form-message')) {
  customElements.define(
    'contact-form-message',
    class ContactForm extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.hidePopups();
        this.closeFormMessage();
        this.autoHideMessage();
      }

      hidePopups() {
        document.body.classList.add('notification-visible');
      }

      showPopups() {
        document.body.classList.remove('notification-visible');
      }

      closeFormMessage() {
        const closeButton = this.querySelector('[data-form-message-close]');
        closeButton.addEventListener('click', this.closeMessage.bind(this));
      }

      closeMessage(e) {
        e.preventDefault();
        this.classList.add('hide-down');
        this.showPopups();
      }

      autoHideMessage() {
        setTimeout(() => {
          this.classList.add('hide-down');
          this.showPopups();
        }, 20000);
      }
    }
  );
}
